<div class="c-bui-search"
  [ngClass]="[
    isFullWide ? 'u-mat-full' : ''
  ]">
  <app-input-text
    [placeholder]="placeholder === 'COMMON.SEARCH' ? (placeholder | translate) : placeholder"
    [prefix]="'magnify'"
    [isSuffixClickable]="clearButtonIsVisible"
    [suffix]="clearButtonIsVisible ? 'close' : ''"
    [formControl]="formControl"
    [autocomplete]="autocomplete"
    [isFullWide]="isFullWide"
    (suffixClickEvent)="clear()">
  </app-input-text>
</div>
